import React from "react";

class Setup extends React.Component {
  render() {
    return <div>Setup</div>;
  }
}
export default Setup;
